import React from 'react';
import { Component } from '@poa/core';
import { observable } from '@poa/state';


class ClientTransferList extends React.Component {
    store; // injected by Poa
    actions; // injected by Poa
    env; // injected by Poa

    localState = observable({
        transfers: [],
    });

    async componentDidMount() {
        try {

            const data = await this.env.http
                .get(`account/client-transfers/${this.store.accounts.originalModel.id}/`)
                .then(response => response.data);

            this.localState.transfers = data;
        } catch (e) {
            console.log(e);
            this.env.alert(
                'Ошибка',
                `Ошибка. Данные не получены.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
            );
        }
    }

    handlChildrenListItemClick = async (index) => {
        await this.actions.generalProfileActions.fetchGeneralProfile(index); 
    }

    buildTransferBody = (transfers) => {
        if (!transfers)
            return null;

        const body = transfers.map((transfer, idx) => {

            return (
                <tr key={transfer.id}>
                    <td style={{ flex: 1, alignItems: 'right', paddingLeft: '20px' }}>{idx} )</td>
                    <td style={{ flex: 1, color: "blue" }}>{transfer.payer_id}</td>
                    <td style={{ flex: 1, alignItems: 'center' }}>{transfer.from_user}</td>
                    <td style={{ flex: 1, alignItems: 'center' }}>{transfer.to_user}</td>
                    <td style={{ flex: 1, alignItems: 'center'}}>{transfer.transfer_date}</td>
                </tr>
            );
        }
        );
        return (body)
    }


    render() {

        return (
            <div className='general_info__content'>
                <>
                    <div className='shift-row'>
                        <div className='links-page-body'>
                            <div className='links-page_popup_content'>
                                <table className='table' style={{ tableLayout: 'fixed' }}>
                                    <thead className='links-page-thead' >
                                        <tr>
                                            <th style={{ flex: 1 }}>№</th>
                                            <th style={{ flex: 1 }}>Клиент</th>
                                            <th style={{ flex: 1 }}>От</th>
                                            <th style={{ flex: 1 }}>Кому</th>
                                            <th style={{ flex: 1 }}>Дата</th>
                                        </tr>
                                    </thead>
                                    <tbody className='links-page-tbody'>
                                        {this.buildTransferBody(this.localState.transfers)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </>
            </div>
        );
    }
}

export default Component({ namespaces: ['account-client-transfers'] })(ClientTransferList);